/* tslint:disable */
/* eslint-disable */
export enum Role {
  AccessDenied = 0,
  Pharmacy = 200,
  PharmacyBasic = 205,
  PartnerProgramPharmacy = 210,
  AnthroposophyUser = 250,
  Pharmacist = 260,
  Administrator = 300,
  LogisticsUser = 310,
  Admin = 444
}
